import { render, staticRenderFns } from "./addJob.vue?vue&type=template&id=54a6b09c&"
import script from "./addJob.vue?vue&type=script&lang=ts&"
export * from "./addJob.vue?vue&type=script&lang=ts&"
import style0 from "./addJob.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports